import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}

import ResourceTable from '@shell/components/ResourceTable';
import { EPINIO_TYPES } from '../types';
import Loading from '@shell/components/Loading';

import { useStore } from 'vuex';
import { ref, computed, onMounted, useAttrs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'configurations',
  props: {
    schema: {}
  },
  setup(__props: any) {

const store = useStore();
const attrs = useAttrs();

const props = __props; // eslint-disable-line @typescript-eslint/no-unused-vars

const pending = ref<boolean>(true);

onMounted(async () => {
  store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.APP });
  store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.SERVICE_INSTANCE });
  await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.CONFIGURATION });

  pending.value = false;
});

const rows = computed(() => {
  return store.getters['epinio/all'](EPINIO_TYPES.CONFIGURATION);
});

return (_ctx: any,_cache: any) => {
  const _component_LinkDetail = _resolveComponent("LinkDetail")!

  return (pending.value)
    ? (_openBlock(), _createBlock(_unref(Loading), { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ResourceTable), _mergeProps(_unref(attrs), {
          rows: rows.value,
          schema: _ctx.schema
        }), {
          "cell:service": _withCtx(({ row }) => [
            (row.service)
              ? (_openBlock(), _createBlock(_component_LinkDetail, {
                  key: row.service.id,
                  row: row.service,
                  value: row.service.meta.name
                }, null, 8, ["row", "value"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, " "))
          ]),
          "cell:boundApps": _withCtx(({ row }) => [
            (row.applications.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.applications, (app, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: app.id
                    }, [
                      _createVNode(_component_LinkDetail, {
                        row: app,
                        value: app.meta.name
                      }, null, 8, ["row", "value"]),
                      _cache[0] || (_cache[0] = _createTextVNode()),
                      (index < row.applications.length - 1)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: app.id + 'i'
                          }, ", "))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, " "))
          ]),
          _: 1,
          __: [1]
        }, 16, ["rows", "schema"])
      ]))
}
}

})